var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vkb-nak-chart"},[_c('highcharts',{ref:"highcharts",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0c6764","hasScoped":false,"optionsId":"16","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=16!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/ruerup_rente/chart.vue
// module id = hObU
// module chunks = 0